const commentContract = Object.seal({
  id: '',
  text: '',
  createdAt: '',
  user: {
    id: '',
    name: ''
  },
  replies: [],
  reactions: []
});

function createComment (comment) {
  return {...commentContract, ...comment};
}

function validateCommentMessage (message) {
  const messageToValidate = message.trim();
  const MAX_MESSAGE_LENGTH = 2700;

  if (messageToValidate.length === 0) {
    return 'Comment message cannot be empty';
  }

  if (messageToValidate.length > MAX_MESSAGE_LENGTH) {
    return `Comment message too long: max of ${MAX_MESSAGE_LENGTH} chars exceeded`;
  }

  return '';
}

export {
  createComment,
  validateCommentMessage
};
